import { Dashboard, KeyboardReturnRounded } from "@material-ui/icons";
import React from "react";
import { cheq, storage, db } from "../firebaseConfig";
import {useAuthState} from 'react-firebase-hooks/auth';
import firebase from "firebase";
import { useState, useHistory } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { Button } from "react-bootstrap";
import { MDCTextField } from "@material/textfield";
import { TextField } from "@material-ui/core";
import Login from "../Login";
import DoctorRegistration from "./doctorreg";

function DoctorRegistrationPortal(){

    const[user] = useAuthState(cheq);

  return(
    user ? <DoctorRegistration/> : <Login/>
  );
}

export default DoctorRegistrationPortal;